<template>
  <div id="home">
    <my-header></my-header>
    <div class="image-store height-auto">
      <img src="/static/images/warehouse.jpg" />
    </div>
    <div class="pd20">

      <div v-if="page && page.id ">
        <h3>{{page.title}}</h3>
        <div class="mt-3 alert alert-info post-content" v-html="page.description"></div>
        <router-link class="btn btn-success w-100" :to="{ name: 'AddWarehouse', params: { }}">{{'Register'|translate}}</router-link>
      </div>

    </div>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'

// import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: 'IntroduceWarehouse',
  components: {
    Loading,
    selectlocation,
    MyHeader
  },

  data () {
    return {
      loading: true,
      page: null
    }
  },
  created () {
    // clone from original params
  },
  methods: {

    loadInfo () {
      Utils.requestV2(this, true)
        .get(`/posts/warehouse`)
        .then(response => {
          this.loading = false
          let data = response.data
          console.log('data', data)
          this.page = data
          console.log('this.page', this.page)
        })
        .catch(error => {
          this.loading = false
          Utils.showErrorMessage(this, error.response)
        })
    }
  },
  mounted () {
    this.loadInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/IntroduceWarehouse.vue